import { storageProvider } from '@ocean/configs'

const MAINTENANCE_NOTIFICATIONS_VIEWED = 'MAINTENANCE_NOTIFICATIONS_VIEWED'

// Maintenance Notifications for page refresh and direct links
class MaintenanceNotificationsUtils {
  viewed = 'VIEWED'

  markMaintenanceNotificationsViewed() {
    storageProvider.setItem(MAINTENANCE_NOTIFICATIONS_VIEWED, this.viewed)
  }

  clearMaintenanceNotificationsViewed() {
    storageProvider.removeItem(MAINTENANCE_NOTIFICATIONS_VIEWED)
  }

  getMaintenanceNotificationsState() {
    return storageProvider.getItem(MAINTENANCE_NOTIFICATIONS_VIEWED)
  }
}

export default new MaintenanceNotificationsUtils()
